module.exports = __webpack_public_path__ + "img/dangyuanjiaoyu_icon.f5fe2dfe.png";